export function formatPhone(phone: string) {
  return phone.replaceAll(/\D/g, "").slice(1);
}
